/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type DroneResponseOperationalStatus =
    (typeof DroneResponseOperationalStatus)[keyof typeof DroneResponseOperationalStatus];

export const DroneResponseOperationalStatus = {
    ACTIVE: 'ACTIVE',
    GROUNDED: 'GROUNDED'
} as const;
